import React, { useEffect, useState, useRef } from "react";
import RegistrationInfo from "./RegistrationInfo";
import Payment from "./Payment";
import UserInfo from "./UserInfo";
import OtherInfoandSubmit from "./OtherInfoandSubmit";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";


function Form() {

  function parseStringToInt(str) {
    // Check if the input is null or undefined
    if (str === null || str === undefined) {
      
      return 0;
    }
  
    // Attempt to parse the string to an integer
    let num = parseInt(str, 10); // Specify radix 10 for decimal numbers
  
    // Check if the result is NaN (Not-a-Number)
    if (isNaN(num)) {
     
      return 0;
    }
  
    return num;
  }
  

  const [eventdata, setData] = useState(null);
  const [hasRequested, setHasRequested] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [eventId , seteventid] = useState();
  const [userId , setuserid] = useState();
  const eventTypeRef = useRef();
  const [openLoader, setOpenLoader] = useState(false);
  const [eventPrice, seteventprice] = useState({
      priceBelow6: 0,
      price6to12: 0,
      priceAdult: 0
    });
const totalTickPrice = useSelector(state => state.totalTicketPrice);
const totalHeadCount = useSelector(state => state.totalHeadCount);

const [checkBoxStates , setCheckBoxStates] = useState(
{ 
  isAllDayChecked : true,
  isSundayChecked : false,
  isSaturdayChecked : false,  
  isEventChecked : false

});
    const [page, setPage] = useState(0);
    const [formData, setFormData] = useState({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      numberBelow6: "",
      numberBetween6To12: "",
      totalVeg:"",
      totalNonveg:"",
      userId : "",
      eventId : "",
      totalTicketPrice:"",
      numberOfAdult:"",
      totalHeadCountPerBooking:"",
      registrationType:""

      
  });
  

    const FormTitles = ["Enter your details", "Registration Info", "Summary"];
  
    const PageDisplay = () => {
      if (page === 0) {
        return <UserInfo formData={formData} setFormData={setFormData} />;
      } else if (page === 1) {
        return <RegistrationInfo formData={formData} setFormData={setFormData} 
        eventPrice={eventPrice} eventType={eventTypeRef}  setEventPrice={seteventprice}
         setcheckBoxStates = {setCheckBoxStates} checkBoxStates = {checkBoxStates} />;
      } else {
        return <OtherInfoandSubmit formData={formData} setFormData={setFormData}
         eventPrice={eventPrice}  setEventPrice={seteventprice}  checkBoxStates = {checkBoxStates}/>;
      }
    };
  
    const validateEmail = (email) => {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(String(email).toLowerCase());
    };

    const validatePhoneNumber = (phoneNumber) => {
      const re = /^[0-9]{10}$/; // Adjust the regex as needed for your phone number format
      return re.test(String(phoneNumber));
    };
      useEffect(() => {
      
      const fetchdata= async () => {
       // Fetch data from the API

     console.log('Making GET request');
     await axios.get(process.env.REACT_APP_API_URL + '/event/get/latest/active') // Replace with your API endpoint
          .then(response => {
           seteventid(response.data.eventId);
           seteventprice(response.data);
           eventTypeRef.current =  response.data.eventType;
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
        }     
        fetchdata();

      }, []
);

const handleUserValidation = () => {
 // e.preventDefault();

  // Manually validate required fields
  let errors = [];
  if (!formData.firstName) {
    errors.push('First name is required.');
  }
  if (!formData.lastName) {
    errors.push('LastName is required.');
  }
  if (!formData.state) {
    errors.push('State is required.');
  }
  if (!formData.city) {
    errors.push('City is required.');
  }
  if (!formData.email || !validateEmail(formData.email) ) {
    errors.push('Valid Email is required.');
  }
  if (!formData.phoneNumber || !validatePhoneNumber(formData.phoneNumber)) {
    errors.push('Valid PhoneNumber is required.');
  }

  if (errors.length > 0) {
    Swal.fire({
      title: 'Error!',
      html: errors.join('<br>'),
      icon: 'error',
      confirmButtonText: 'OK',
      background: '#f0f0f0', // Custom background color
      customClass: {
        popup: 'my-custom-popup', // Custom CSS class for the popup
        title: 'my-custom-title', // Custom CSS class for the title
        confirmButton: 'my-custom-confirm-button', // Custom CSS class for the confirm button
      },
    });
    return;
  }

  // Call the user registration function
  handleUserRegistration();
 // setPage((currPage) => currPage + 1);
};

const handleUserRegistration = async () => {
  const submissionData = {
    ...formData
  };
 
  // Show loading indicator
  Swal.fire({
    title: 'Submitting...',
    text: 'Please wait while we process your request.',
    icon: 'info',
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
    timer: 1500
  });
     
  // Send the user data to the server using Axios
  const response = await axios.post(process.env.REACT_APP_API_URL + '/user/create', submissionData)
 .then(response => {
  setuserid(response.data.userId);
  setMessage('User created successfully!');

  // Close the loading indicator
  Swal.close();

  // Show a success alert
Swal.fire({
  title: 'Submitted!',
  text: 'User information has been successfully submitted.',
  icon: 'success',
  confirmButtonText: 'OK',
  background: '#f0f0f0', // Custom background color
});
  setPage((currPage) => currPage + 1);
})
.catch(error => {

Swal.fire({
  title: 'Error!',
  text: 'Failed to create User. Please try again.',
  icon: 'error',
  confirmButtonText: 'OK',
  background: '#f0f0f0', // Custom background color
}).then((result) => {
  if (result.isConfirmed) {
    // Perform actions after the alert is confirmed
    navigate('/'); // Redirect to the home page or another appropriate page
  };
});
})
}

 const isNullOrZero = (value) => {
    return value === null || value === 0;
  };

const handleFormValidation = () => {
  // e.preventDefault();
 
   // Manually validate required fields
   let errors = [];

    // Convert totalVeg and totalNonveg to integers
    const totalVeg = parseInt(formData.totalVeg, 10);
    const totalNonveg = parseInt(formData.totalNonveg, 10);
    const totalAdult = parseInt(formData.numberOfAdult, 10);

    // Check if totalVeg or totalNonveg is null or zero
    if (!totalVeg && !totalNonveg && !totalAdult) {
       errors.push('Atleast one adult is required for registration.');
 
    }
  
 
   if (errors.length > 0) {
     Swal.fire({
       title: 'Error!',
       html: errors.join('<br>'),
       icon: 'error',
       confirmButtonText: 'OK',
       background: '#f0f0f0', // Custom background color
       customClass: {
         popup: 'my-custom-popup', // Custom CSS class for the popup
         title: 'my-custom-title', // Custom CSS class for the title
         confirmButton: 'my-custom-confirm-button', // Custom CSS class for the confirm button
       },
     });
     return;
   }
   
  // handleFormRegistration();
   setPage((currPage) => currPage + 1);
 };

const handleFormRegistration = async () => {
  setOpenLoader(true);
  console.log('user id :' + userId);
  console.log('event id :' + eventId);
  console.log("Event Type : ", eventTypeRef.current)
  console.log("total head count : ", totalHeadCount)

  console.log(formData);

  const updatedFormData = {
    ...formData,
    userId: userId ,
    eventId: eventId,
    eventType: eventTypeRef.current,
    numberOfAdult: formData.registrationType === "EVENT_ONLY" ? parseStringToInt(formData.numberOfAdult) : 
    parseStringToInt(formData.totalNonveg)+parseStringToInt(formData.totalVeg),
    totalHeadCountPerBooking:totalHeadCount > 0 ? totalHeadCount : parseStringToInt(formData.numberOfAdult)+parseStringToInt(formData.numberBelow6)+
    parseStringToInt(formData.numberBetween6To12),
    totalTicketPrice: totalTickPrice > 0 ?  totalTickPrice : (parseStringToInt(formData.numberBelow6) * eventPrice.priceBelow6)
         +(parseStringToInt(formData.numberBetween6To12) * eventPrice.price6to12) 
         +(parseStringToInt(formData.totalVeg) * eventPrice.priceAdult)
         +(parseStringToInt(formData.totalNonveg) * eventPrice.priceAdult)
    //paymentStatus: "UP"
  };

  setFormData(updatedFormData);

  // Show loading indicator
  Swal.fire({
    title: 'Submitting...',
    text: 'Please wait while we process your request.',
    icon: 'info',
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
    timer: 1500
  });

  axios.post(`${process.env.REACT_APP_API_URL}/event/registration/register/${eventId}/user/${userId}`, updatedFormData)
 .then(response => {
      console.log(response.data);
      setOpenLoader(false);
    
    Swal.fire({
      title: 'Submitted!',
      text: 'Registration information has been successfully submitted.',
      icon: 'success',
      confirmButtonText: 'OK',
      background: '#f0f0f0'// Custom background color
    }
  ).then((result) => {
    if (result.isConfirmed) {
      
      sessionStorage.setItem('updatedFormData', JSON.stringify(updatedFormData));
      // Perform actions after the alert is confirmed
      navigate('/thank-you' , { state : updatedFormData }); // Redirect to the home page or another appropriate page
    }
  });

    })
    .catch(error => {
      console.error('Error:', error);
      setMessage('Failed to register User. Please try again.');
      Swal.fire({
        title: 'Error!',
        text: 'Failed to register User. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        background: '#f0f0f0', // Custom background color
      }).then((result) => {
        if (result.isConfirmed) {
          // Perform actions after the alert is confirmed
          navigate('/'); // Redirect to the home page or another appropriate page
        };
      });
      });

    // Close the loading indicator
    Swal.close();
    }
    




  return (
    <>
    <Backdrop 
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} 
        open={openLoader}>
            <CircularProgress color="inherit" />
     </Backdrop>
    <div className="form">
      {/* <div className="progressbar">
        <div
          style={{ width: page === 0 ? "33.3%" : page === 1 ? "66.6%" : "100%" }}
        ></div>
      </div> */}
      <div className="form-container" style={{marginTop:"50px"}}>
        <div className="header">
          <h1>{FormTitles[page]}</h1>
        </div>
        <div className="body">{PageDisplay()}</div>
        <div className="footer">
          <button className='wizard-button'
            disabled={page == 0}
            onClick={() => {
            
            setPage((currPage) => currPage - 1); 
            }}
          >
            Prev
          </button>
          <button className='wizard-button'
            onClick={() => {
              if (page === FormTitles.length - 1) {
               // alert("FORM SUBMITTED");
               handleFormRegistration();             
                
              }
              else if(page === 0)
                {
                 //alert("user info SUBMITTED");
                   handleUserValidation();
                // handleUserRegistration();
                // setPage((currPage) => currPage + 1);
                }
               else {
                if(page === 1)
                {
                  handleFormValidation();
                }
                else{
                setPage((currPage) => currPage + 1);
                }
              }

              

            }}
          >
            {page === FormTitles.length - 1 ? "Submit" : "Next"}
          </button>
        </div>
      </div>
     
    </div>
    </>
  );
}

export default Form;
